export default __webpack_public_path__ + "static/experienceImg3-774250b1fa78641019c2c0d7ea352d07.webp";